const formatExtraProductName = (name: string) => `Extras: [${name}]`;

export default formatExtraProductName;
